/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CollectionsModule
 */

import { AviPermissionResource } from 'generated-types';
import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { TenantUsageItem } from 'ng/modules/items/factories/tenant-usage.item.factory';

export type TTenantUsageCollection = typeof TenantUsageCollection;

/**
 * @description Tenant Usage Collection Factory
 * @author Shubham Bindal
 */
export class TenantUsageCollection extends Collection {
    public static readonly ngDependencies = [TenantUsageItem];

    constructor(args = {}) {
        const extendedArguments = {
            objectName: 'licensing/usage/tenant',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_SYSTEMCONFIGURATION,
            ...args,
        };

        super(extendedArguments);
        this.itemClass_ = this.getNgDependency(TenantUsageItem);
    }
}
